import { Option } from '../../option.js';
export class FlatStructuralTransformer {
    constructor(preserveDuplicates = false) {
        this.preserveDuplicates = preserveDuplicates;
    }
    transform(sourcedValueOptions) {
        const q = sourcedValueOptions.slice();
        let collection = this.preserveDuplicates
            ? new ListCollection()
            : new SetCollection(o => o._id);
        while (q.length > 0) {
            const next = q.shift();
            if (next instanceof Option) {
                collection.add(next);
            }
            else {
                q.unshift(...next.children);
            }
        }
        return collection.values();
    }
}
export class ListCollection {
    constructor() {
        this.items = [];
    }
    add(item) {
        this.items.push(item);
    }
    values() {
        return this.items;
    }
}
export class SetCollection {
    constructor(keySelector) {
        this.keySelector = keySelector;
        this.items = new Map();
    }
    add(item) {
        this.items.set(this.keySelector(item), item);
    }
    values() {
        return Array.from(this.items.values());
    }
}
//# sourceMappingURL=FlatStructuralTransformer.js.map